import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-sanction-form',
  templateUrl: './payroll-sanction-form.component.html',
  styleUrls: ['./payroll-sanction-form.component.css']
})
export class PayrollSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component.ts